
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import uiService from "@/services/uiService";

export default Vue.extend({
  data() {
    return {
      binding: {},
      logo: '',
    };
  },
  async created() {
    await this.getClientSetting()
    msDataProvider.bindDataMany(["uiConfig"], this.binding, this, null, this);
  },
  methods: {
    openHelpCenter() {
      uiService.executeCommand('helpCenterShow');
    },
    async getClientSetting() {
      const res: any = await msDataProvider.getData("clientSetting")
      if (res && res.settings && res.settings.logo && res.settings.logo.main_logo) {
        this.logo = res.settings.logo.main_logo
      }
    },
    getImg() {
      if (this.logo) {
        return this.logo
      }
      return require('../../assets/images/MSuite-trang.svg')
    }
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
